import { BackboneResultsView as ResultsView } from "../resultsview/ResultsView";
import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import template from "./templates/layout";

class ResultsLayout extends Backbone.Marionette.Layout {
    constructor(...args) {
        super(...args);
        this.onRender = this.onRender.bind(this);
        this.onHarvestHistoryRefresh = this.onHarvestHistoryRefresh.bind(this);
    }

    onRender() {
        const resultsView = new (asMarionetteView(ResultsView))({
            model: this.model,
            collection: this.collection || new Backbone.Collection(),
            sorts: this.model.get("sorts"),
            hasHover: false
        });
        this.results.show(resultsView);
    }

    onHarvestHistoryRefresh(){
        this.trigger("get_harvest_history");
    }
}

ResultsLayout.prototype.template = template;

ResultsLayout.prototype.triggers =
    {"click button.refresh": "harvest:history:refresh"};

ResultsLayout.prototype.regions = {
    "header": "div.header",
    "results": "div.results",
    "footer": "div.footer"
};

export default ResultsLayout;



// WEBPACK FOOTER //
// ./app/lib/hex/lib/resultslayout/ResultsLayout.js